import { uri } from '../../api-endpoint';
import {
  IProjectAPIValidationError,
  IProjectFromAPISuccessResponse
} from '../../type-conversion/project/from-api-repsonse';
import { createTemplateFn } from '../common';

export const unapproveProject = (token: string) => (projectId: number) =>
  createTemplateFn(
    token,
    uri.projectUnapprove(projectId),
    () => ({}),
    IProjectFromAPISuccessResponse,
    IProjectAPIValidationError
  );
